module.exports = __webpack_public_path__ + "assets/media/day8.35163af2.mp3";